import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { postUnsubscribe } from '../utils/bedrockAPI';
import './Unsubscribe.css';

export default function Unsubscribe(props) {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let isMounted = true;

    async function unsubscribe(userId) {
      try {
        const result = await postUnsubscribe(userId);
        if (!isMounted) return;
        if (result && result.success === true) {
          setStatus('success');
        } else {
          setStatus('error');
        }
      } catch (error) {
        if (isMounted) setStatus('error');
      }
    }

    if (props.match.params.userid) {
      unsubscribe(props.match.params.userid);
    } else if (isMounted) {
      setStatus('error');
    }

    return () => {
      isMounted = false;
    };
  }, [props.match.params.userid]);

  return (
    <div className="unsubscribe-page">
      <div className="unsubscribe-panel">
        {status === 'loading' && (
          <>
            <div className="unsubscribe-spinner" aria-hidden="true" />
            <h1 className="unsubscribe-title">Updating your preferences…</h1>
            <p className="unsubscribe-text">Please wait a moment.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="unsubscribe-icon unsubscribe-icon--success" aria-hidden="true">
              <i className="fas fa-check" />
            </div>
            <h1 className="unsubscribe-title">You&apos;ve been unsubscribed</h1>
            <p className="unsubscribe-text">
              You will no longer receive notification emails from Bedrock Wireless.
              You can still log in to manage alerts from your account settings.
            </p>
            <Link to="/login" className="btn btn-brand-outline btn-compact">
              Return to Log In
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="unsubscribe-icon unsubscribe-icon--error" aria-hidden="true">
              <i className="fas fa-exclamation" />
            </div>
            <h1 className="unsubscribe-title">Unable to unsubscribe</h1>
            <p className="unsubscribe-text">
              This link may be invalid or has already been used. Contact support if you
              continue to receive unwanted emails.
            </p>
            <Link to="/" className="btn btn-brand-outline btn-compact">
              Go to Home
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
